import { render } from "./fundsTransfe.vue?vue&type=template&id=d601710a&scoped=true"
import script from "./fundsTransfe.vue?vue&type=script&lang=js"
export * from "./fundsTransfe.vue?vue&type=script&lang=js"

import "./fundsTransfe.vue?vue&type=style&index=0&id=d601710a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d601710a"]])

export default __exports__